import axios from 'axios';
import { toast } from 'react-toastify';
import sessionHelpers from './utils/sessionHelpers';
import storageHelpers from './utils/storageHelpers';

import * as routes from './routes';

const axiosInitializer = {
  load: () => {
    axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

    // Request interceptor
    axios.interceptors.request.use(
      (config) => {
        const currentUser = sessionHelpers.currentUser();
        // default headers
        config.headers['Accept'] = 'application/vnd.surefood.in; version=v1';
        config.headers['Content-Type'] = 'application/json';

        if (currentUser) {
          config.headers['X-Auth-Token'] = currentUser.jwt_token;
        }

        return config;
      },
      (error) => Promise.reject(error)
    );

    axios.interceptors.response.use(
      (response) => {
        if (response.headers['content-type'] === 'application/csv') {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(
            'download',
            `Report-${new Date().toLocaleDateString()}.csv`
          ); //or any other extension
          document.body.appendChild(link);
          link.click();
        }
        if (response.data && response.data.message) {
          toast.success(response.data.message);
        }

        // After successful login, set logged in user details in the localstorage
        if (response.config.url === routes.LOGIN_URL) {
          sessionHelpers.logIn(response.data.data.attributes);
          if (response.data.data.meal_types) {
            storageHelpers.setItem('mealTypes', response.data.data.meal_types);
          }
        }

        return response;
      },
      (error) => {
        if (!error.response) {
          toast.error('Server is not reachable');
        }

        const currentUser = sessionHelpers.currentUser();

        if (currentUser && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            storageHelpers.setItem('axiosReferrer', window.location.pathname);
            //eslint - disable - line;

            sessionHelpers.logOut();
            window.location.href = routes.LOGIN_URL; // eslint-disable-line
          }

          if (
            error.response.status === 422 &&
            error.response.data.authorization_failure
          ) {
            window.location.href = routes.ROOT_URL; // eslint-disable-line
          }
        }

        if (error.response && error.response.data) {
          const { data } = error.response;
          if (data.message) toast.error(data.message);
        }

        return Promise.reject(error);
      }
    );
  },
};

export default axiosInitializer;
